import createPushNotification from 'src/graphql/mutations/pushNotifications/createPushNotification';

import post from './shared/post';

export default {
  createPushNotification(values) {
    return post(values, createPushNotification);
  },
};
